import axios from 'axios';
import qs from 'querystring';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retriveAppEnscapePanorama(context, query) {
      try {
        const enscapePanoramas = await axios.get(`/app-viewer-enscape-panorama?${qs.stringify(query)}`, { withCredentials: true });
        return enscapePanoramas.data;
      } catch (error) {
        throw error;
      }
    },
    async retriveAppEnscapePanoramaById(context, id) {
      try {
        const enscapePanoramas = await axios.get(`/app-viewer-enscape-panorama/${id}`, { withCredentials: true });
        return enscapePanoramas.data;
      } catch (error) {
        throw error;
      }
    },
    async createAppEnscapePanorama(context, { payload, imagePanorama }) {
      try {
        const bodyFormData = new FormData();
        bodyFormData.set('imagePanorama', imagePanorama);

        bodyFormData.append('payload', JSON.stringify(payload));

        const config = { withCredentials: true, 'Content-Type': 'multipart/form-data' };
        const response = await axios.post('/app-viewer-enscape-panorama', bodyFormData, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async updateAppEnscapePanorama(context, { id, pointId, payload }) {
      try {
        const config = { withCredentials: true };
        const response = await axios.patch(`/app-viewer-enscape-panorama/${id}/point/${pointId}`, payload, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    async deleteAppEnscapePanorama(context, { id, pointId }) {
      try {
        const config = { withCredentials: true };
        const response = await axios.delete(`/app-viewer-enscape-panorama/${id}/point/${pointId}`, config);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
